/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ExpiringLeaseTerms } from './ExpiringLeaseTerms';
import {
    ExpiringLeaseTermsFromJSON,
    ExpiringLeaseTermsFromJSONTyped,
    ExpiringLeaseTermsToJSON,
    ExpiringLeaseTermsToJSONTyped,
} from './ExpiringLeaseTerms';
import type { CostInformation } from './CostInformation';
import {
    CostInformationFromJSON,
    CostInformationFromJSONTyped,
    CostInformationToJSON,
    CostInformationToJSONTyped,
} from './CostInformation';
import type { ProcurementTypeCount } from './ProcurementTypeCount';
import {
    ProcurementTypeCountFromJSON,
    ProcurementTypeCountFromJSONTyped,
    ProcurementTypeCountToJSON,
    ProcurementTypeCountToJSONTyped,
} from './ProcurementTypeCount';

/**
 * 
 * @export
 * @interface VehicleFleetStatistics
 */
export interface VehicleFleetStatistics {
    /**
     * 
     * @type {Array<ProcurementTypeCount>}
     * @memberof VehicleFleetStatistics
     */
    procurementTypeCounts: Array<ProcurementTypeCount>;
    /**
     * 
     * @type {Array<CostInformation>}
     * @memberof VehicleFleetStatistics
     */
    costInformation: Array<CostInformation>;
    /**
     * 
     * @type {ExpiringLeaseTerms}
     * @memberof VehicleFleetStatistics
     */
    expiringLeaseTerms: ExpiringLeaseTerms;
    /**
     * 
     * @type {number}
     * @memberof VehicleFleetStatistics
     */
    totalElofleetVehicles: number;
    /**
     * 
     * @type {number}
     * @memberof VehicleFleetStatistics
     */
    totalNonElofleetVehicles: number;
}

/**
 * Check if a given object implements the VehicleFleetStatistics interface.
 */
export function instanceOfVehicleFleetStatistics(value: object): value is VehicleFleetStatistics {
    if (!('procurementTypeCounts' in value) || value['procurementTypeCounts'] === undefined) return false;
    if (!('costInformation' in value) || value['costInformation'] === undefined) return false;
    if (!('expiringLeaseTerms' in value) || value['expiringLeaseTerms'] === undefined) return false;
    if (!('totalElofleetVehicles' in value) || value['totalElofleetVehicles'] === undefined) return false;
    if (!('totalNonElofleetVehicles' in value) || value['totalNonElofleetVehicles'] === undefined) return false;
    return true;
}

export function VehicleFleetStatisticsFromJSON(json: any): VehicleFleetStatistics {
    return VehicleFleetStatisticsFromJSONTyped(json, false);
}

export function VehicleFleetStatisticsFromJSONTyped(json: any, ignoreDiscriminator: boolean): VehicleFleetStatistics {
    if (json == null) {
        return json;
    }
    return {
        
        'procurementTypeCounts': ((json['procurementTypeCounts'] as Array<any>).map(ProcurementTypeCountFromJSON)),
        'costInformation': ((json['costInformation'] as Array<any>).map(CostInformationFromJSON)),
        'expiringLeaseTerms': ExpiringLeaseTermsFromJSON(json['expiringLeaseTerms']),
        'totalElofleetVehicles': json['totalElofleetVehicles'],
        'totalNonElofleetVehicles': json['totalNonElofleetVehicles'],
    };
}

export function VehicleFleetStatisticsToJSON(json: any): VehicleFleetStatistics {
    return VehicleFleetStatisticsToJSONTyped(json, false);
}

export function VehicleFleetStatisticsToJSONTyped(value?: VehicleFleetStatistics | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'procurementTypeCounts': ((value['procurementTypeCounts'] as Array<any>).map(ProcurementTypeCountToJSON)),
        'costInformation': ((value['costInformation'] as Array<any>).map(CostInformationToJSON)),
        'expiringLeaseTerms': ExpiringLeaseTermsToJSON(value['expiringLeaseTerms']),
        'totalElofleetVehicles': value['totalElofleetVehicles'],
        'totalNonElofleetVehicles': value['totalNonElofleetVehicles'],
    };
}

